import React, { Component } from 'react';
import styled from 'styled-components';
import {connect} from 'react-redux';
import Header from './components/header/'

import TitleBodyNormal from './components/titlebody/normal'
import TitleBodySmall from './components/titlebody/small'
import Menubar from './components/titlebody/menubar'


import './App.css';



class App extends Component {

  constructor(props){

    super(props)

    this.state={

        winheight: 0,
        winwidth: 0,
        titlebodynormal: true,
        extrasmall:false
    }
  }

componentDidMount(){
      window.addEventListener("resize", this.resize.bind(this));
      this.resize();
}


resize() {

    this.setState({

        winheight: window.innerHeight,
        winwidth: window.innerWidth,

    })
    if(window.innerWidth < 830) {
      this.setState({titlebodynormal:false})
    }
      else{
           this.setState({titlebodynormal:true})
      }
    if(window.innerWidth < 420){
          this.setState({extrasmall:true})
    }
      else{
        this.setState({extrasmall:false})
    }


}


render (){

    const { winwidth, winheight, titlebodynormal, extrasmall } = this.state


    return (
    <div className='App' >

        <Header winwidth={winwidth} winheight={winheight} extrasmall={extrasmall}/>

      {titlebodynormal ?
        <TitleBodyNormal winwidth={winwidth} winheight={winheight} />
        :
        <TitleBodySmall extrasmall={extrasmall} winwidth={winwidth} winheight={winheight} />
      }


    </div>
  );
}
}

export default connect(
  state => ({

        titleunits:state.titleunits,

  }),

)(App);
